module.exports = __webpack_public_path__ + "media/images/icons/list-5d2ac557c1e3c9b7b725f56eb4d87c18.png";